import {
  createWardrobeConfigurator,
  getFullPalette,
} from './wardrobeConfigFactory'
import { OpeningType } from '~/components/ThreeDModel/furnitureConfig'

export const DEFAULT_WARDROBE = {
  width: 200,
  height: 260,
  depth: 50,
  plintHeight: 0,
  selectedColor: 'Beige Almond',
}

export const WardrobeProductConfigurator = createWardrobeConfigurator({
  handleOptions: [
    OpeningType.ProfileHandleLong,
    OpeningType.ProfileHandle,
    OpeningType.RoundHandle,
  ],
  defaultHandle: OpeningType.ProfileHandleLong,
  colorOptions: getFullPalette(),
  defaultColor: 'Beige Almond', // actual default is set in configUrl.ts (productDefaultColors)
})
